/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_DescriptionInputs */

const en_guide_json_schema_description = /** @type {(inputs: Guide_Json_Schema_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn JSON Schema for data validation. Understand types, required fields, patterns, and how to ensure your JSON data is always correct.`)
};

const ko_guide_json_schema_description = /** @type {(inputs: Guide_Json_Schema_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`데이터 유효성 검사를 위한 JSON Schema를 배워보세요. 타입, 필수 필드, 패턴을 이해하고 JSON 데이터의 정확성을 보장하세요.`)
};

const ja_guide_json_schema_description = /** @type {(inputs: Guide_Json_Schema_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データ検証のためのJSON Schemaを学びましょう。型、必須フィールド、パターンを理解し、JSONデータが常に正しいことを保証する方法を解説します。`)
};

/**
* | output |
* | --- |
* | "Learn JSON Schema for data validation. Understand types, required fields, patterns, and how to ensure your JSON data is always correct." |
*
* @param {Guide_Json_Schema_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_description = /** @type {((inputs?: Guide_Json_Schema_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_description(inputs)
	if (locale === "ko") return ko_guide_json_schema_description(inputs)
	return ja_guide_json_schema_description(inputs)
});